import { render, staticRenderFns } from "./other-summary.vue?vue&type=template&id=758e5997&"
import script from "./other-summary.vue?vue&type=script&lang=js&"
export * from "./other-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports